import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FlowComponent } from '../../../modules/flow/flow.component';
import { KeywordsComponent } from '../../../modules/keywords/keywords.component';
import { RoutingComponent } from '../../../modules/routing/routing.component';
import { PaydAuthGuard } from '../portal/payd-auth.guard';
import { AccessDeniedComponent } from '../../components/access-denied/access-denied.component';
import { ApiIntegrationComponent } from '../../../modules/api-integration/api-integration.component';
import { AnalyticsSettingsComponent } from '../../../modules/analytics-settings/analytics-settings.component';
import { SettingsComponent } from '../../../modules/settings/settings.component';
import { DataChangesGuard } from './can-deactivate.guard';
import { AssetsLibraryComponent } from '../../../modules/assets-library/assets-library.component';
import { FlowDeletionSuccessComponent } from '../../../modules/flow/components/delete-flow/flow-deletion-success/flow-deletion-success.component';

const appRoutes: Routes = [
  { path: 'access-denied', component: AccessDeniedComponent },
  {
    path: '',
    canActivate: [PaydAuthGuard],
    children: [
      {
        path: '',
        canActivateChild: [PaydAuthGuard],
        children: [
          {
            path: 'flow/:env/:entityType/:entityId/:flowPath',
            component: FlowComponent,
            canDeactivate: [DataChangesGuard],
          },
          { path: 'keywords', component: KeywordsComponent },
          { path: 'apiIntegration', component: ApiIntegrationComponent },
          { path: 'settings', component: SettingsComponent },
          { path: 'routing', component: RoutingComponent },
          { path: 'assets-library', component: AssetsLibraryComponent },
          { path: 'analytics-settings', component: AnalyticsSettingsComponent},
          { path: 'deletion/success/:flowName', component: FlowDeletionSuccessComponent },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [CommonModule, RouterModule.forRoot(appRoutes, { enableTracing: false, relativeLinkResolution: 'legacy' })],
  declarations: [],
  exports: [RouterModule],
})
export class AppRoutingModule {}
